import { apiClient } from '@/shared/api';
import type { KnowledgeSourceListItem } from './types';

/**
 * Получение источника знаний по идентификатору (GET /knowledge-source/{id}).
 * `silentError` подавляет toast: отсутствие источника — штатный случай, о нём сообщает сам UI
 */
export const fetchKnowledgeSource = async (id: number | string): Promise<KnowledgeSourceListItem> => {
  const { data } = await apiClient.get<KnowledgeSourceListItem>(`/knowledge-source/${id}`, { silentError: true });
  return data;
};
